"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Error = void 0;
var react_1 = __importDefault(require("react"));
var Error = function (props) {
    var iterate = function (error, strs) {
        for (var p in error) {
            var v = error[p];
            if (!v) {
                continue;
            }
            if (typeof v == 'string') {
                strs.push(v);
                continue;
            }
            iterate(v, strs);
        }
    };
    if (!props.error) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    else if (typeof props.error == 'string') {
        return react_1.default.createElement("span", null, props.error);
    }
    else {
        var strs = [];
        iterate(props.error, strs);
        return (react_1.default.createElement(react_1.default.Fragment, null, strs.map(function (e, i) { return (react_1.default.createElement("span", { key: i },
            e,
            react_1.default.createElement("br", null))); })));
    }
};
exports.Error = Error;
//# sourceMappingURL=Error.js.map